// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.tokoin",
    name: "Tokoin | My-T Wallet",
    homepage: "https://tokoin.io",
    image_id: "88a2518c-16c2-4ee3-4699-1a1c6903bc00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/my/app/tokow/id1489276175",
        android: "https://play.google.com/store/apps/details?id=com.tokoin.wallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "mtwallet://app",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map